module.exports = __webpack_public_path__ + "img/product23p.616671b7.png";